import type { GetTikTokSANAuthenticationUrlAction } from './getAuthenticationUrl.action';
import type { GetTikTokSANAdvertisersAction } from './getAdvertisers.action';
import type { GetSanAdAccountZeitStatusAction } from '../../actions/getSANAdPartnerZeitStatus';

export * from './getAuthenticationUrl.action';
export * from './getAdvertisers.action';

export type TikTokSANAction =
  | GetTikTokSANAuthenticationUrlAction
  | GetSanAdAccountZeitStatusAction
  | GetTikTokSANAdvertisersAction;
